import React from 'react';
import Input from '../elements/Input';

const ProceedingDetails = ({ formData, handleChange }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4 border-b pb-1 text-gray-800 dark:text-white">Proceeding Details</h2>
      <div className="grid md:grid-cols-2 gap-6 my-6">
        <Input label="Venue" type="text" name="venue" value={formData.venue} onChange={handleChange} />
        <Input label="Stage" type="text" name="stage" value={formData.stage} onChange={handleChange} />
        <Input label="Key Date" type="text" name="key_date" value={formData.key_date} onChange={handleChange} />
      </div>
    </div>
  );
};

export default ProceedingDetails;